import { InfiniteScroller, Row, Separator, H6 } from '@fs/zion-ui'
import React, { useReducer, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from '@fs/zion-router'
import { usePageView } from '@fs/zion-analytics'
import { usePageTitle } from '../../app/PageTitleContext'
import getTypeFiltersInitialState from '../../common/TypeFiltersState'
import TreeChangesFiltersButton from './TreeChangesFiltersButton'
import TreeChangesTable from './TreeChangesTable'
import useTreeChanges from './useTreeChanges'

export default function TreeChanges() {
  usePageView({ page_detail: 'DMConsole:TreeChanges' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.tree.changes'))
  const [treeContributionsData, setTreeContributionsData] = useState()
  const { treeId } = useParams()
  const [filtersState, setFiltersState] = useReducer(
    (_oldstate, newState) => JSON.parse(JSON.stringify(newState)),
    getTypeFiltersInitialState({ t, type: 'tree' })
  )
  const { fetchMoreTreeContributions } = useTreeChanges({
    treeContributionsData,
    setTreeContributionsData,
    treeId,
    filtersState,
  })

  if (!treeContributionsData) return null

  return (
    <>
      <Row>
        <TreeChangesFiltersButton
          growX
          filtersState={filtersState}
          setFiltersState={setFiltersState}
          treeId={treeId}
          treeContributionsData={treeContributionsData}
          setTreeContributionsData={setTreeContributionsData}
        />
        <H6 noShrinkX>
          {t('-tree-contributions.numberOfChanges', '{changes} changes', {
            changes: treeContributionsData.tfUserContributions.contributions.length,
          })}
        </H6>
      </Row>
      {treeContributionsData.tfUserContributions.contributions?.length > 0 && (
        <>
          <Separator size="xs" />
          <TreeChangesTable treeContributionsData={treeContributionsData} />
          <InfiniteScroller fetchMore={fetchMoreTreeContributions}>
            <div />
          </InfiniteScroller>
        </>
      )}
    </>
  )
}
